import { PayloadAction } from '@reduxjs/toolkit';
import { DefaultFollowUpCreateFormState, EActionState, IAppointmentCombinedState, IFollowUpCreateFormState, IListValue } from 'models';

export interface IState {
	activityId: string;
	create: EActionState;
	open: boolean;
	durations: string[];
	followUps: IAppointmentCombinedState[];
	form: IFollowUpCreateFormState;
	init: EActionState;
	inPersonStartTimes: IListValue[];
	opportunityId: string;
	opportunityFollowUpStatus: string;
	phoneStartTimes: IListValue[];
	onSuccess?: () => PayloadAction<any>;
}

export const initialState: IState = {
	activityId: '',
	create: EActionState.COMPLETED,
	open: false,
	durations: [],
	followUps: [],
	form: DefaultFollowUpCreateFormState,
	init: EActionState.PENDING,
	inPersonStartTimes: [],
	opportunityId: '',
	opportunityFollowUpStatus: '',
	phoneStartTimes: [],
	onSuccess: undefined
};
